import styled, { css } from 'styled-components'
import { black, border1, danger, dangerTint, darkGrey, white } from '@/theme/colors'
import { layers, radii, shadows } from '@/theme/tokens'
import { Button } from '@components/Button'

/** Quiet by default, where the trigger rides along on a card; `$strong` where it is the row's one action. */
export const MenuButton = styled(Button).attrs({ variant: 'icon' as const })<{ $strong?: boolean }>`
	flex: none;
	color: ${({ $strong }) => ($strong ? black : darkGrey)};
`

/** The menu's panel: the Dropdown's portaled list, anchored under its trigger and right-aligned to it. */
export const MenuPanel = styled.div<{ $top: number; $right: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $right }) => $right}px;
	transform: translateX(-100%);
	min-width: 160px;
	padding: 6px;
	background: ${white};
	border: 1px solid ${border1};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.overlay};
	z-index: ${layers.popover};
	display: flex;
	flex-direction: column;
`

export const MenuItem = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })<{ $danger?: boolean }>`
	justify-content: flex-start;
	width: 100%;
	${({ $danger }) =>
		$danger &&
		css`
			color: ${danger};

			&:hover:not(:disabled) {
				background: ${dangerTint};
			}
		`}
`
